export const FIREBASE_ERRORS = {
  "auth/email-already-in-use": "Ya existe una cuenta con ese correo electrónico.",
  "auth/weak-password": "La contraseña debe tener al menos 6 caracteres.",
  "auth/user-not-found": "No existe un usuario con esas credenciales.",
  "auth/wrong-password": "Credenciales incorrectas",
  "auth/invalid-email": "El formato del correo electrónico es incorrecto.",
  "auth/user-not-found": "No hemos encontrado un usuario con esas credenciales."
}